/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { Directive, Input } from '@angular/core';
var /** @type {?} */ nextUniqueId = 0;
/**
 * Single error message to be shown underneath the form field.
 */
var MatError = (function () {
    function MatError() {
        this.id = "mat-error-" + nextUniqueId++;
    }
    MatError.decorators = [
        { type: Directive, args: [{
                    selector: 'mat-error',
                    host: {
                        'class': 'mat-error',
                        'role': 'alert',
                        '[attr.id]': 'id',
                    }
                },] },
    ];
    /**
     * @nocollapse
     */
    MatError.ctorParameters = function () { return []; };
    MatError.propDecorators = {
        'id': [{ type: Input },],
    };
    return MatError;
}());
export { MatError };
function MatError_tsickle_Closure_declarations() {
    /** @type {?} */
    MatError.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatError.ctorParameters;
    /** @type {?} */
    MatError.propDecorators;
    /** @type {?} */
    MatError.prototype.id;
}
//# sourceMappingURL=error.js.map